import * as React from 'react';

function SvgWhatsapp(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M256 0C115.3 0 0 115.3 0 256c0 46.5 12.598 91.5 36.3 131.102L0 512l124.898-36.3C164.5 499.397 209.5 512 256 512c140.7 0 256-115.3 256-256S396.7 0 256 0zm0 0"
        fill="#00dd7b"
      />
      <path
        d="M512 256c0 140.7-115.3 256-256 256V0c140.7 0 256 115.3 256 256zm0 0"
        fill="#00cc71"
      />
      <path
        d="M417.2 364.3l-12 11.7c-16.802 16.8-55.802 15.598-80.7 10.8-22.2-4.198-46-14.1-68.5-27.902C194.8 321.7 139.3 255.7 125.8 196.301c-9.3-40.203-4.198-75 9-88.5l12-12c6.602-6.301 17.098-6.301 23.7 0l47.7 47.699c3.3 3.3 5.1 7.5 5.1 12s-1.8 8.7-5.1 12l-12 11.7c-12.9 13.198-12.9 34.5 0 47.698l49.8 48.903 29.098 28.8c13.203 13.2 35.504 13.2 48.703 0l11.699-12.003c6.3-6 17.7-6 24 0l47.7 47.703c6.3 6.597 6.6 17.097 0 24zm0 0"
        fill="#ececf1"
      />
      <path
        d="M417.2 364.3l-12 11.7c-16.802 16.8-55.802 15.598-80.7 10.8-22.2-4.198-46-14.1-68.5-27.902v-83.097l29.098 28.8c13.203 13.2 35.504 13.2 48.703 0l11.699-12.003c6.3-6 17.7-6 24 0l47.7 47.703c6.3 6.597 6.6 17.097 0 24zm0 0"
        fill="#e2e2e7"
      />
    </svg>
  );
}

export default SvgWhatsapp;
